/* Why we believe in sleep - scroll reveals and carousel dots for sections/why-sleep-*.liquid.
   Each section carries data-wbs-section. Reveal groups ([data-wbs-group]) get .is-in
   when they scroll into view, and their [data-wbs-item] children animate in with
   the stagger set by --i. Tracks ([data-wbs-track]) keep their dot buttons in step
   with the scroll position, and [data-wbs-prev]/[data-wbs-next] arrows step a
   card at a time. The theme editor shows everything at once. */
(function () {
  if (window.__whySleep) return;
  window.__whySleep = true;
  var designMode = window.Shopify && window.Shopify.designMode;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(section) {
    var groups = section.querySelectorAll('[data-wbs-group]');
    if (designMode || reduced || section.hasAttribute('data-wbs-still') || !('IntersectionObserver' in window)) {
      section.classList.add('wbs--still');
      groups.forEach(function (g) { g.classList.add('is-in'); });
      return;
    }
    // Anything already on screen when the script runs was painted visible: keep it
    // that way rather than hiding it and fading it back in.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    groups.forEach(function (g) {
      var r = g.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) g.classList.add('is-in');
    });
    section.classList.add('wbs--js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    groups.forEach(function (g) { if (!g.classList.contains('is-in')) io.observe(g); });
  }

  function carousel(track) {
    var items = Array.prototype.slice.call(track.children);
    var frame = track.parentElement;
    var scope = frame.classList.contains('wbs-carousel__frame') ? frame.parentElement : frame;
    var dots = scope.querySelector('[data-wbs-dots]');
    var prev = frame.querySelector('[data-wbs-prev]');
    var next = frame.querySelector('[data-wbs-next]');
    var behavior = reduced ? 'auto' : 'smooth';

    function positionOf(i) { return items[i].offsetLeft - items[0].offsetLeft; }

    // Arrows step one card at a time and wrap round at either end, like the
    // product page carousels (product-master-pdp.js initScrollCarousel).
    function step(direction) {
      var max = track.scrollWidth - track.clientWidth;
      if (items.length < 2 || max <= 2) return;
      var current = track.scrollLeft;
      if (direction > 0 && current >= max - 2) return track.scrollTo({ left: 0, behavior: behavior });
      if (direction < 0 && current <= 2) return track.scrollTo({ left: max, behavior: behavior });
      var target = null;
      for (var i = 0; i < items.length; i++) {
        var left = positionOf(i);
        if (direction > 0 && left > current + 2) { target = left; break; }
        if (direction < 0 && left < current - 2) target = left;
      }
      if (target === null) target = direction > 0 ? max : 0;
      track.scrollTo({ left: Math.min(max, target), behavior: behavior });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if (!dots) return;
    var buttons = Array.prototype.slice.call(dots.children);
    var current = -1;

    function setActive(index) {
      if (index === current) return;
      current = index;
      buttons.forEach(function (b, i) { b.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return setActive(0);
      if (track.scrollLeft >= max - 4) return setActive(items.length - 1);
      var start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
      var best = 0;
      var bestDistance = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.getBoundingClientRect().left - start);
        if (d < bestDistance) { bestDistance = d; best = i; }
      });
      setActive(best);
    }

    buttons.forEach(function (button, i) {
      button.addEventListener('click', function () {
        track.scrollTo({ left: positionOf(i), behavior: behavior });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    root.querySelectorAll('[data-wbs-section]').forEach(function (section) {
      if (section.dataset.wbsReady) return;
      section.dataset.wbsReady = '1';
      reveal(section);
      section.querySelectorAll('[data-wbs-track]').forEach(carousel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
